import { cn } from '@/platform/lib/utils';

const TableRow = ({ error = false, className, children, ...props }) => (
    <tr
        // Table skips striping and the hover fill for [data-error] rows, so the
        // red stays consistent regardless of the row's position.
        data-error={error || undefined}
        className={cn(
            'border-b border-gray-100 transition-colors last:border-0',
            error && 'bg-red-50 text-red-700 hover:bg-red-100',
            className
        )}
        {...props}
    >
        {children}
    </tr>
);

export default TableRow;
